import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CallsFilter = ({fromDate = null, toDate = null, setFromDate, setToDate, clearDates}) => {
    const clearEnabled = fromDate != null || toDate != null;
    return <div className="flex flex-col gap-2">
        <DatePicker
            className="h-8 w-full font-medium text-sm pl-2 ring-1 rounded"
            placeholderText="From"
            selected={fromDate}
            onChange={setFromDate}
            maxDate={toDate || new Date()}
        />
        <DatePicker
            className="h-8 w-full pl-2 font-medium text-sm ring-1 rounded"
            placeholderText="To"
            selected={toDate}
            onChange={setToDate}
            minDate={fromDate}
            maxDate={new Date()}
        />
        <button
            onClick={clearDates}
            className={"whitespace-nowrap relative inline-flex h-10 items-center justify-center rounded-xl border px-4 text-sm font-medium transition " + (clearEnabled
                ? "border-gray-300 bg-slate-100 text-slate-700 hover:bg-slate-200"
                : "border-gray-200 bg-slate-50 text-gray-400")}
            disabled={!clearEnabled}
        >
            {"Clear"}
        </button>
    </div>;
};

export default CallsFilter;
